export default __webpack_public_path__ + "static/media/market.67b51e56.svg";